import {
  LocalUuidKey,
  LocalOpenIdKey,
  LocalUnionIDKey,
  LocalDeviceIdKey,
  LocalStorageTokenKey,
  LocalStorageAnonymousUserID,
  LocalStorageAnonymousRealUserID,
} from '@whelk/const/src/token';

export const checkToken = () => {
  return Boolean(localStorage.getItem(LocalStorageTokenKey));
};

export const setStorageToken = (token: string) => {
  window.localStorage.setItem(LocalStorageTokenKey, token);
};

export const getStorageToken = (): string => localStorage.getItem(LocalStorageTokenKey) ?? '';

export const removeStorageToken = () => {
  window.localStorage.removeItem(LocalStorageTokenKey);
};

export const removeStorageUnionID = () => {
  window.localStorage.removeItem(LocalUnionIDKey);
};

export const checkDeviceId = () => {
  return Boolean(localStorage.getItem(LocalDeviceIdKey));
};

export const getUuid = () => {
  return localStorage.getItem(LocalUuidKey);
};

export const setUuid = (uuid: string) => {
  return localStorage.setItem(LocalUuidKey, uuid);
};

export const setOpenID = (openID: string) => {
  return localStorage.setItem(LocalOpenIdKey, openID);
};

export const setUnionID = (unionID: string) => {
  return localStorage.setItem(LocalUnionIDKey, unionID);
};

export const setDeviceId = (deviceId: string) => {
  return localStorage.setItem(LocalDeviceIdKey, deviceId);
};

export const setAnonymousUser = (userID: string, realUserID: string) => {
  localStorage.setItem(LocalStorageAnonymousUserID, userID);
  localStorage.setItem(LocalStorageAnonymousRealUserID, realUserID);
};
